import { render, staticRenderFns } from "./break-dialog.vue?vue&type=template&id=8056702a&scoped=true"
import script from "./break-dialog.vue?vue&type=script&lang=js"
export * from "./break-dialog.vue?vue&type=script&lang=js"
import style0 from "./break-dialog.vue?vue&type=style&index=0&id=8056702a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8056702a",
  null
  
)

export default component.exports